import styled, { css } from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  width: 152px;
  height: 183px;

  ${media.medium`
    width: 25vw;
    height: 32vw;
  `}

  ${props => props.flipped && css`
    margin: 0 0 0 auto;
  `}
`;
